import { Stack } from "@mui/material";
import { IconProps } from "../../types/genereal";
import React from "react";

type Props = IconProps & {
  children: React.ReactNode;
  style?: React.CSSProperties;
  onClick?: () => void;
};

export const IconWrapper = ({
  children,
  width,
  height,
  rotate,
  style,
  onClick,
}: Props) => {
  return (
    <Stack
      onClick={onClick}
      style={style}
      sx={{ width, height, transform: `rotate(${rotate}deg)` }}
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
    >
      {children}
    </Stack>
  );
};
